import { BorderAll } from "@mui/icons-material"
import { styled } from "@mui/material"

const Overview = styled("div")(({ theme }) => ({
  "& .MuiTypography-h2": {
    color: theme.palette.pink.main,
    fontFamily: "Montserrat",
    fontSize: " 16px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: " normal",
    "&.font-24": {
      fontSize: "24px",
      "@media (max-width: 900px)": {
        fontSize: "18px",
      },
    },
    "&.font-20": {
      fontSize: "20px",
      "@media (max-width: 900px)": {
        fontSize: "16px",
      },
    },
    "&.font-12": {
      fontSize: "12px",
    },
  },
  "& .MuiTypography-body1": {
    color: "#626262",
    fontFamily: "Montserrat",
    fontSize: " 14px",
    fontStyle: "normal",
    fontWeight: "400",
    display: "block",
    lineHeight: " 13px",
  },
  "& .datetime": {
    "& .weekday": {
      fontWeight: "bold",
      color: "#777",
    },
  },
  "&.fw-600": {
    fontWeight: "600",
  },
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.pink.main,
    "& .MuiListItem-root ": {
      color: theme.palette.white.main,
      "& svg": {
        color: theme.palette.white.main,
      },
    },
  },
  "& .text-success-provider": {
    color: theme.palette.green.main,
  },
  "& .dashboard-table-wrapper": {
    backgroundColor: "transparent",
    boxShadow: "none",
    "& .dashboard-table": {
      backgroundColor: "transparent",
      boxShadow: "none",
      "& thead": {
        "& th": {
          color: theme.palette.gray.main700,
          fontFamily: "Montserrat",
          fontSize: " 15px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: " 13px",
          minWidth: "66px",
          "@media (max-width: 900px)": {
            fontSize: "13px",
          },
        },
      },
      "& .minh-1": {
        minHeight: "1px",
      },
      "& .service-head": {},
      "& .datetime": {
        "& span": {
          width: "130px",
          lineHeight: "23px",
          minHeight: "21px",
        },
        "& .weekday": {
          fontWeight: "bold",
          color: "#777",
        },
      },
      "& .Pending": {
        color: "#FFA639",
      },

      "& .Assigned": {
        color: "#009C35",
      },
      "& .Rejected": {
        color: "#FE2323",
      },
      "& .Active": {
        color: "#FFA639",
      },
      "& .Completed": {
        color: "#009C35",
      },
      "& .Cancelled": {
        color: "#FE2323",
      },
      "& .location": {
        "& span": {
          width: "184px",
          lineHeight: "23px",
          fontSize: "12px",
        },
      },
      "& .language": {
        width: "184px",
        fontSize: "12px",
      },
      "& .action-btn": {
        gap: "20px",
      },
      "& tbody tr ": {
        borderRadius: "16px ",
        overflow: "hidden",
        backgroundColor: "#fff",
        boxShadow: "0px 8px 6px -3px #00000008",
        transition: "all 0.4s ease",
      },
      "& tbody tr:hover ": {
        backgroundColor: "#f1f1f1",
      },
      "& tbody tr td:first-child": {
        width: "85px",
        borderRadius: "16px 0 0 16px ",
        overflow: "hidden",
        "& div": {
          "& img": {
            width: "100%",
          },
        },
      },
      "& tbody tr td:last-child": {
        "& span": {
          borderRadius: "0px 16px 16px 0",
        },
      },
      "& td": {
        padding: "0",
        paddingRight: "10px",
        // borderBottom: "none",
        backgroundColor: "transparent",
        "& span": {
          position: "relative",
          minHeight: "75px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "transparent",
          color: theme.palette.gray.main700,
          fontFamily: "Montserrat",
          fontSize: " 14px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: " 13px",
          //   boxShadow: "0px 8px 6px -3px #00000008",
          "@media (max-width: 900px)": {
            fontSize: "12px",
          },
        },
      },
      "& .view-profile": {
        display: "inline-block",
        minWidth: "80px",
        padding: "12px 10px",
        border: "1px solid",
        borderRadius: "8px",
        borderColor: theme.palette.pink.main,
        fontFamily: "Montserrat",
        color: theme.palette.pink.main,
        fontSize: "14px",
        textAlign: "center",
        textDecoration: "none",
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: theme.palette.pink.main, // Apply hover background color
          color: "white", // Change text color on hover
        },
      },
      "& .user-img": {
        width: "85px",
        "& div": {
          width: "85px",
          "& img": {
            width: "100%",
            borderRadius: "5px 0px 0px 5px",
          },
        },
      },
      "& tbody tr th:first-child": {
        "& span": {
          borderRadius: "16px 0px 0px 16px",
        },
      },
      "& th": {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: "none",
        backgroundColor: "transparent",
        "& span": {
          position: "relative",
          minHeight: "75px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "start",
          backgroundColor: "transparent",
          color: theme.palette.black,
          fontFamily: "Montserrat",
          fontSize: " 14px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: " 13px",
          gap: "6px",
          padding: "0 20px",
          boxShadow: "0px 8px 6px -3px #00000008",
          zIndex: "2",
          "& span": {
            minHeight: "auto",
            flexDirection: "row",
            alignItems: "center",
            gap: "2px",
            fontSize: "12px",
            color: theme.palette.gray.main700,
            padding: 0,
            "& svg": {
              fill: theme.palette.yellow.main,
            },
          },
        },
      },
    },
  },
  "& .track-btn": {
    width: "100%",
    padding: "9px",
    textAlign: "center",
    color: theme.palette.white.main,
    fontSize: "14px",
    backgroundColor: theme.palette.pink.main,
    borderColor: theme.palette.pink.main,
    fontFamily: "Montserrat",
    "& svg": {
      marginLeft: "9px",
    },
    "&:disabled": {
      color: "#B9B9B9",
      border: "1px solid #B9B9B9",
      backgroundColor: "transparent",
    },
  },
  "& .Advertisement": {
    borderRadius: " 16px",
    background: "linear-gradient(90deg, #F475A4 38.96%, #DD5084 99.94%)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "end",
    "& .MuiButtonBase-root": {
      background: theme.palette.white.main,
      color: theme.palette.pink.main,
    },
  },
  "& .white-space": {
    whiteSpace: "nowrap",
  },
  "& .photo-upload": {
    width: "60px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  "& .back-btn": {
    backgroundColor: "#F475A4",
    minWidth: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    marginBottom: "21px",
    "&.step-back-btn": {
      position: "absolute",
      top: "30px",
      left: "50px",
    },
    "& svg": {
      fill: "#ffffff",
    },
    "&.profile-back": {
      position: "absolute",
      top: 0,
      left: 0,
    },
  },
  "& .service-text": {
    fontSize: "32px",
    fontWeight: "500",
    "&.started": {
      color: "#00C14D",
    },
    "&.stopped": {
      color: "#F83939",
    },
  },
  "& .otp-box": {
    maxWidth: "520px",
    // minHeight: "400px",
    padding: "47px 10px",
    background: theme.palette.white.main,
    borderRadius: "16px",
    border: "1px solid #EDEDED",
  },
  "& .otp-box-3": {
    display: "block",
  },
  "& .service-detail-box": {
    maxWidth: "520px",
    padding: "47px 10px",
    background: theme.palette.white.main,
    borderRadius: "16px",
    border: "1px solid #EDEDED",
  },
  "& .status-text": {
    fontSize: "20px",
    fontWeight: "400",
    fontFamily: "Montserrat",
    border: "1px solid #dddddd",
    boxShadow: "rgba(0, 0, 0, 0.23) 0px 4px 25px 0px",
    padding: "10px",
    borderRadius: "8px",
    "@media (max-width: 600px)": {
      fontSize: "14px",
      padding: "5px",
    },
    color: theme.palette.black.main,
    "& .completed": {
      color: theme.palette.green.main,
    },
    "& .cancelled": {
      color: theme.palette.red.main,
    },
  },
  "& .green-heading": {
    color: "#00c14d",
    fontSize: "36px",
    fontWeight: "600",
    lineHeight: "34px",
  },
  "& .green-heading1": {
    color: "#000",
    fontSize: "20px",
    fontWeight: "600",
    lineHeight: "34px",
  },
  "& .payment-status": {
    color: "#000",
    fontSize: "20px",
    fontWeight: "600",
    lineHeight: "34px",
  },
  "& .text-data": {
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  "& .pending": {
    color: "#de8705",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "34px",
    backgroundColor: "#FFB80042",
    border: "unset",
    borderRadius: "48px",
    padding: "8px 40px",
    marginLeft: "10px",
  },
  "& .ls-8": {
    letterSpacing: "8px",
  },
  "& .approved-card": {
    backgroundColor: theme.palette.white.main,
    padding: "9px 19px 14px",
    boxShadow: "0px 4px 20px 0px #00000008",
    borderRadius: "16px",
    "&.pending-card": {
      borderColor: theme.palette.yellow.main,
    },
    "&.rejected-card": {
      borderColor: theme.palette.red.main,
    },
  },
  "& .view-profile": {
    display: "inline-block",
    width: "135px",
    padding: "12px 10px",
    border: "1px solid #F475A4",
    borderRadius: "8px",
    color: "#F475A4",
    fontSize: "14px",
    fontFamily: "Montserrat",
    textAlign: "center",
    textDecoration: "none",
  },
  "& .upcoming-booking-slider": {
    paddingBottom: "10px",
    "& .slick-track": {
      display: "flex",
      gap: "16px",
      margin: "0",
    },
    "& .slick-dots": {
      "& li": {
        "& button": {
          "&:before": {
            fontSize: "12px",
            color: "#DEDEDE",
            opacity: 1,
          },
        },
        "&.slick-active": {
          "& button": {
            "&:before": {
              color: theme.palette.pink.main,
            },
          },
        },
      },
    },
    "& .slick-arrow": {
      "&:before": {
        color: theme.palette.pink.main,
        fontSize: "30px",
        opacity: 1,
      },
      "&.slick-prev": {
        left: "-18px",
        zIndex: 2,
      },
      "&.slick-next": {
        right: "-14px",
        zIndex: 2,
      },
      "&.slick-disabled": {
        display: "none !important",
      },
    },
  },
  "& .dark-divider": {
    border: "1px dashed #C0C0C0",
  },

  "& .timeline-graph": {
    "& .MuiTimelineConnector-root": {
      display: "none",
    },
    "& .MuiTimelineDot-root": {
      margin: 0,
      width: "65px",
      height: "65px",
      borderRadius: "16px",
      padding: "0",
      border: "none",
      backgroundColor: theme.palette.white.main,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0px 4px 21px 0px #00000008",
      "& .timeline-step": {
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: " 9px",
        backgroundColor: theme.palette.pink.main,
        fontSize: "16px",
        fontWeight: "500",
        fontFamily: "Montserrat",
        color: theme.palette.white.main,
      },
    },
    "& .timeline-content": {
      // maxWidth: "500px",
      borderRadius: "16px",
      backgroundColor: theme.palette.white.main,
      padding: "17px 24px",
      marginTop: "-27px",
    },
    "& ul": {
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "1px",
        height: "100%",
        backgroundColor: "#AAAAAA",
      },
      "& li": {
        marginBottom: "60px",
        "@media (max-width: 600px)": {
          marginBottom: "20px",
        },
        "&:nth-child(2n)": {
          "& .timeline-content": {
            marginLeft: "auto",
          },
        },
      },
    },
    "& .timeline-heading": {
      fontSize: "16px",
      fontFamily: "Montserrat",
      fontWeight: "400",
      color: theme.palette.pink.main,
      marginBottom: "12px",
    },
    "& .timeline-desc": {
      fontSize: "16px",
      fontFamily: "Montserrat",
      fontWeight: "400",
      color: "#818181",
      marginBottom: "12px",
      lineHeight: "19px",
    },
  },
  "& .timeline-btn": {
    padding: "9px 25px",
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "Montserrat",
    color: "#ffffff",
    border: "1px solid #f475a4",
    backgroundColor: "#f475a4",
    borderRadius: "8px",
    textTransform: "capitalize",
    "& svg": {
      marginLeft: "9px",
      fill: "#A0A0A0",
    },
  },

  "& .offer-box": {
    background: "linear-gradient(90.06deg, #F475A4 38.96%, #DD5084 99.94%);",
    borderRadius: "16px",
    padding: "19px 39px",
    position: "relative",
    "& .logo-white": {
      maxWidth: "148px",
      width: "100%",
      marginBottom: "12px",
    },
    "& .off-discount": {
      fontSize: "48px",
      color: theme.palette.white.main,
      letterSpacing: "4.8px",
      marginBottom: "22px",
      lineHeight: "initial",
      fontFamily: "Racing Sans One",
    },
    "& .valid-text": {
      color: "#FFD4E4",
      fontSize: "12px",
      fontFamily: "Montserrat",
    },
    "& .valid-date-text": {
      fontSize: "16px",
      color: theme.palette.white.main,
      fontFamily: "Montserrat",
      fontWeight: "500",
    },
    "& .book-text": {
      fontSize: "12px",
      color: theme.palette.white.main,
      fontFamily: "Montserrat",
      marginBottom: "9px",
    },
    "& .book-now-btn": {
      maxWidth: "135px",
      width: "100%",
      textAlign: "center",
      textDecoration: "none",
      borderRadius: "4px",
      padding: "12px 7px",
      background: theme.palette.white.main,
      color: theme.palette.pink.main,
      fontSize: "14px",
      fontFamily: "Montserrat",
      display: "inline-block",
    },
    "& .offer-img": {
      position: "absolute",
      bottom: 0,
      right: "20px",
      maxWidth: "285px",
      width: "100%",
    },
  },
}))
const Flexbox = styled("div")(({ theme }) => ({
  display: "flex",
  columnGap: "15px",
  flexWrap: "wrap",
  "& .MuiTypography-body1": {
    color: theme.palette.pink.main,
    fontFamily: "Nunito Sans",
    fontSize: " 18px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: " 18px",
    textAlign: "center",
    marginTop: "10px",
  },
  // "& .MuiTypography-body1":  {
  //   color: theme.palette.grey.main200,
  //   fontFamily: "Montserrat",
  //   fontSize: " 19px",
  //   fontStyle: "normal",
  //   fontWeight: "400",
  //   lineHeight: " 18px",
  //   textAlign: "center",
  // },
  // "& .MuiTypography-body1": {
  //   color: theme.palette.gray.main500,
  //   fontFamily: "Montserrat",
  //   fontSize: " 14px",
  //   fontStyle: "normal",
  //   fontWeight: "400",
  //   display: "block",
  //   lineHeight: " 13px",
  // },
  "& .overview-card": {
    background: theme.palette.white.main,
    boxShadow: "0px 4px 20px 2px rgba(0, 0, 0, 0.03)",
    padding: "40px 27px",
    width: "auto",
    minWidth: "158px",
    borderRadius: "16px",
    transition: ".2s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
    "& .pink-text": {
      color: theme.palette.pink.main,
    },
  },
  "& .darkpink-text": {
    color: "#AD2B82",
  },
  "& .font-24": {
    fontSize: "24px",
  },
}))
const Upcoming = styled("div")(({ theme }) => ({
  maxWidth: "500px",

  "& .MuiTypography-h2": {
    color: theme.palette.pink.main,
    fontFamily: "Poppins",
    fontSize: " 16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: " normal",
  },
  "& .Headingbox": {
    borderRadius: "16px 16px 0 0",

    display: "flex",
    justifyContent: "space-between",
    background: theme.palette.white.main,
    boxShadow: "0px 4px 27px 0px rgba(0, 0, 0, 0.07)",
    padding: "15px",
  },
  "& .ContentBox": {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px",
    background: theme.palette.white.main,
    "& .MuiGrid-root": {
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "normal",
      marginTop: "20px",
    },
    "& .MuiButton-root": {
      borderColor: theme.palette.pink.main,
      color: theme.palette.pink.main,
      fontFamily: "Montserrat",
    },
  },
}))
const Bookedlog = styled("div")(({ theme }) => ({
  padding: "45px 0",

  "& .MuiTypography-h2": {
    color: theme.palette.pink.main,
    fontFamily: "Poppins",
    fontSize: " 16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: " normal",
  },
}))
const Toprated = styled("div")(({ theme }) => ({
  display: "flex",

  gap: "10px",
  img: {
    height: "113px",
    objectFit: "Cover",
    width: "100%",
    borderRadius: " 8px",
  },
  "& .flexdiv": {
    display: "flex",
    gap: "16px",
    padding: "16px",
    backgroundColor: theme.palette.white.main,
    borderRadius: "8px",
  },
  "& .MuiTypography-root ": {
    fontFamily: "Poppins",
    fontSize: " 12px",
    fontStyle: "normal",
    fontWeight: "300",
    lineHeight: " normal",
    textAlign: "start",
  },
}))
const Toprated1 = styled("div")(({ theme }) => ({
  padding: "45px 0",
  "& .MuiTypography-h2": {
    color: theme.palette.pink.main,
    fontFamily: "Poppins",
    fontSize: " 16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: " normal",
  },
}))
const TableAppointment = styled("div")(({ theme }) => ({
  "& .MuiTableCell-root": {
    fontFamily: " Nunito Sans",
    padding: "0",
    borderBottom: "0",
  },
  "th.MuiTableCell-root.MuiTableCell-head ": {
    color: "#7c7c7c",
    padding: "10px 0",
  },
  td: {
    background: theme.palette.white.main,
  },
}))

export {
  Overview,
  Flexbox,
  Upcoming,
  Bookedlog,
  Toprated,
  Toprated1,
  TableAppointment,
}
